import {
  BinSizeTypes,
  ConditionalFormattingTypes,
  DataProfilingTypes,
  DatasetResult,
  FlamingoResponse,
  FlamingoTypes,
  ModeModel,
} from '@mode/shared/contract-common';
import { ModeExportPlan } from 'libs/shared/contract-common/src/lib/flamingo.types';
import { Observable } from 'rxjs';
import { QueryResult } from '@mode-switch/query';
import { DataRole } from '@mode-switch/express';

export abstract class FlamingoFacade {
  abstract completedPlanRefs$: Observable<FlamingoTypes.FlamingoPlanRef>;
  abstract createPlanIdFromRefId(refId: string): Observable<string>;
  abstract createPlanFromPlanId(planId: string): Observable<Readonly<FlamingoTypes.ModeSelectPlan>>;
  abstract createStateFromPlanId(planId: string): Observable<Readonly<FlamingoTypes.PlanStatus>>;
  abstract createReadyFromPlanId(planId: string): Observable<boolean>;
  abstract createErrorFromPlanId(planId: string): Observable<Readonly<FlamingoResponse.FlamingoErrorResponse>>;
  abstract createExportFromPlanId(planId: string): Observable<Readonly<string | Blob>>;
  abstract createRecordsFromPlanId(
    planId: string
  ): Observable<{ columns: readonly QueryResult.Column<DataRole>[]; content: readonly QueryResult.Item[] } | undefined>;
  abstract createResultFromPlanId(planId: string): Observable<Readonly<FlamingoTypes.ModeSelectResult>>;
  abstract createCountFromPlanId(planId: string): Observable<number | undefined>;
  abstract createColumnsByRefId(refId: string): Observable<readonly QueryResult.Column<DataRole>[]>;
  abstract createDataProfilingFromVizToken(vizToken: string): Observable<Readonly<DataProfilingTypes.DataProfilingMap>>;
  abstract createBinSizeToFieldMapFromVizToken(vizToken: string): Observable<Readonly<BinSizeTypes.BinSizeToFieldMap>>;
  abstract createConditionalFormattingFromVizToken(
    vizToken: string
  ): Observable<Readonly<ConditionalFormattingTypes.ConditionalFormattingMap>>;
  abstract createLoadingByPlanId(planId: string): Observable<boolean>;
  abstract createInitByPlanId(planId: string): Observable<boolean>;
  abstract createPageLoadingByPlanId(planId: string): Observable<boolean>;
  abstract createFailedByPlanId(planId: string): Observable<boolean>;
  abstract createDomainRecordsSelector(planId: string): Observable<FlamingoTypes.DomainHash | undefined>;
  abstract getPlanFromRefId(refId: string): Observable<Readonly<FlamingoTypes.ModeSelectPlan>>;
  abstract executePagePlan(
    plan: FlamingoTypes.ModeSelectPlan,
    refId: string,
    queryRunToken: string,
    allowRefresh: boolean
  ): void;
  abstract getContent(refId: string): Observable<FlamingoTypes.RecordsResult['content']>;
  abstract performDomainQuery(datasetResult: DatasetResult, fields: FlamingoTypes.ModeFields, model: ModeModel): string;
  abstract exportCsv(refId: string, plan: ModeExportPlan, queryRunToken: string): void;
}
